import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Cover from './components/cover';
import MainPage from './components/pages/mainPage';
import AboutPage from './components/pages/aboutUsPage';
import ProjectsPage from './components/pages/projectsPage';
import TeamPage from './components/pages/teamPage';
import ContactsPage from './components/pages/contactsPage';
import HowToHelpPage from './components/pages/howToHelpPage';

const App = () => {
  const [showCover, setShowCover] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);
  const [fadeInMainContent, setFadeInMainContent] = useState(false);

  useEffect(() => {
        // Start fade-out effect before hiding cover
        const timer = setTimeout(() => {
            setFadeOut(true);
            setTimeout(() => {
                setShowCover(false);
                setFadeInMainContent(true); // Trigger fade-in for main content
            }, 500);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

  return (
    <Router>
      <div>
        {showCover && <Cover fadeOut={fadeOut} />}
        
        {!showCover && (
          <div className={fadeInMainContent ? 'fade-in' : ''}>
            <Routes>
              <Route path="/" element={<MainPage />} />
              <Route path="/sobre-nos" element={<AboutPage />} />
              <Route path="/projetos" element={<ProjectsPage />} />
              <Route path="/equipa" element={<TeamPage />} />
              <Route path="/contactos" element={<ContactsPage />} />
              <Route path="/como-ajudar" element={<HowToHelpPage />} />
            </Routes>
          </div>
        )}
      </div>
    </Router>
  );
};

export default App;